import { all, takeEvery, put, call } from 'redux-saga/effects'
import { notification } from 'antd'
import actions from './actions'
import { list, find, save, remove } from '../../services/deficiency'
import { SAVE_200_MSG, SAVE_200_DESC, DEL_200_MSG, DEL_200_DESC } from '../../constants'

function* fetchDeficiencysRefresh() {
  let fe = JSON.parse(localStorage.getItem('fetchDeficiencys'))
  if (fe == null) {
    fe = {}
    fe.size = localStorage.getItem('pageSize') || 15
    fe.index = 0
    fe.searchTerm = '%20'
    fe.orderBy = '%20'
  } else {
    fe.searchTerm = '%20'
    fe.orderBy = '%20'
  }
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, fe.size, fe.index, fe.searchTerm, fe.orderBy)
  yield put({
    type: actions.LIST_DEFICIENCY,
    result,
  })
}

function* fetchDeficiencys({ size, index, searchTerm, orderBy, date, status }) {
  size = size || localStorage.getItem('pageSize') || 15

  const savedFilters = localStorage.getItem('deficiencyFilters')

  if (savedFilters) {
    const parsedFilters = JSON.parse(savedFilters)

    date = date || parsedFilters.date || null
    status = status || parsedFilters.status || ''
  }

  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, size, index, searchTerm, orderBy, date, status)
  yield put({
    type: actions.LIST_DEFICIENCY,
    result,
  })
}

function* fetchDeficiencyEdit({ id, openModal }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(find, id, openModal)
  console.log('fetchDeficiencyEdit', result)
  yield put({
    type: actions.EDIT_DEFICIENCY,
    result,
    openModal,
  })
}

function* fetchDeficiencySave(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(save, values)
  if (result !== null) {
    notification.success({ message: SAVE_200_MSG, description: SAVE_200_DESC })
  }
  yield put({
    type: actions.SAVE_DEFICIENCY_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_DEFICIENCYS,
  })
}

function* fetchDeficiencyDelete(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(remove, values)
  if (result !== null) {
    notification.success({ message: DEL_200_MSG, description: DEL_200_DESC })
  }
  yield put({
    type: actions.DELETE_DEFICIENCY_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_DEFICIENCYS,
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_DEFICIENCYS, fetchDeficiencys),
    takeEvery(actions.FETCH_DEFICIENCY, fetchDeficiencyEdit),
    takeEvery(actions.SAVE_DEFICIENCY, fetchDeficiencySave),
    takeEvery(actions.DELETE_DEFICIENCY, fetchDeficiencyDelete),
    takeEvery(actions.RE_FETCH_DEFICIENCYS, fetchDeficiencysRefresh),
  ])
}
